import axios from "./http";

let baseUrl = "";

// 条形码设置
export function getBarcode(params) {
  return axios.get(`${baseUrl}/syapi/config/barcode?type=3`,params);
}
//激活码
export function getActivationCode(params) {
	return axios.post(`${baseUrl}/syapi/Config/getActivationCode`, params);
}

// 小票字段
export function getReceiptField() {
  return axios.get(`${baseUrl}/syapi/config/receiptField`);
}

// 标价签字段
export function bidPriceField() {
  return axios.get(`${baseUrl}/syapi/config/bidPriceField`);
}
// 条码字段
export function barcodeField() {
  return axios.get(`${baseUrl}/syapi/config/barcodeField`);
}

export function orderTestPrint(params) {
  return axios.post(`${baseUrl}/syapi/dayin/orderTestPrint`, params);
}

// 小票打印内容保存
export function receiptsave(data) {
  return axios.post(
    `${baseUrl}/syapi/config/receiptsave`,
    data
    // qs.stringify(data, { indices: false })
  );
}

// 标价签打印内容保存
export function bidpricesave(data) {
  return axios.post(`${baseUrl}/syapi/config/bidpricesave`, data);
}
// 标价签打印内容保存
export function delPrint(data) {
  return axios.post(`${baseUrl}/syapi/dayin/del_print`, data);
}


// 条码标签字段保存
export function barcodeFieldSave(data) {
  return axios.post(`${baseUrl}/syapi/config/barcodeFieldSave`, data);
}

export function addFeie(data) {
  return axios.post(`${baseUrl}/syapi/dayin/addfeie`, data);
}

export function get_print_list(data) {
  return axios.post(`${baseUrl}/syapi/dayin/get_print_list`, data);
}

// 抹零方式
export function zerotype() {
  return axios.get(`${baseUrl}/syapi/config/zerotype`);
}

// 抹零方式设置
export function zerotypesave(params) {
  return axios({
    url: `${baseUrl}/syapi/config/zerotypesave`,
    method: "post",
    params,
  });
}


// 副屏广告保存
export function secondscreenad() {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenad`,
    method: "get",
  });
}
// 副屏广告保存
export function saveShoukuanLink(data) {
  return axios({
    url: `${baseUrl}/syapi/config/saveShoukuanLink`,
    method: "post",
		 data,
  });
}

export function saveCode(data) {
  return axios({
    url: `${baseUrl}/syapi/config/saveCode`,
    method: "post",
		 data,
  });
}


export function getCode(data) {
  return axios({
    url: `${baseUrl}/syapi/config/getCode`,
    method: "post",
		 data,
  });
}

export function addCode(data) {
  return axios({
    url: `${baseUrl}/syapi/config/addCode`,
    method: "post",
		 data,
  });
}

export function delCode(data) {
  return axios({
    url: `${baseUrl}/syapi/config/delCode`,
    method: "post",
		 data,
  });
}
export function deleteCodeOrderDetail(data) {
  return axios({
    url: `${baseUrl}/syapi/config/deleteCodeOrderDetail`,
    method: "post",
		 data,
  });
}
export function saveCodeOrder(data) {
  return axios({
    url: `${baseUrl}/syapi/config/saveCodeOrder`,
    method: "post",
		 data,
  });
}





// 副屏广告保存
export function test64(data) {
  return axios({
    url: `${baseUrl}/syapi/config/test64`,
    method: "post",
		 data,
  });
}

// 副屏广告保存
export function secondscreenadsave(data) {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenadsave`,
    method: "post",
    data,
  });
}

// 副屏广告删除
export function secondscreenaddel(data) {
  return axios({
    url: `${baseUrl}/syapi/config/secondscreenaddel`,
    method: "post",
    data,
  });
}
// 获取主题颜色 收款按钮背景色 主题字体颜色
export function getColorConfig() {
  return axios({
    url: `${baseUrl}/syapi/config/color`,
    method: "get",
  });
}
// 设置主题颜色 收款按钮背景色 主题字体颜色
export function setCOlorConfig(data) {
  return axios({
    url: `${baseUrl}/syapi/config/colorSave`,
    method: "post",
    data,
  });
}
// 获取打印机信息ev
export function getDeviceInfo() {
  return axios({
    url: `${baseUrl}/syapi/config/portSet`,
    method: "get",
  });
}
// 保存打印机信息
export function setDeviceInfo(data) {
  return axios({
    url: `${baseUrl}/syapi/config/portSetSave`,
    method: "post",
    data,
  });
}
// 获取logo
getLogo
export function getLogo() {
  return axios({
    url: `${baseUrl}/syapi/config/baseic`,
    method: "get",
  });
}
export function getFujiafeiData(params) {
  return axios.post(`${baseUrl}/syapi/Fujiafei/getFujiafeiData`, params);
}
export function addFujiafeiData(params) {
  return axios.post(`${baseUrl}/syapi/Fujiafei/addFujiafeiData`, params);
}
export function editFujiafeiData(params) {
  return axios.post(`${baseUrl}/syapi/Fujiafei/editFujiafeiData`, params);
}
export function fujiafeiDelData(params) {
  return axios.post(`${baseUrl}/syapi/Fujiafei/fujiafeiDelData`, params);
}



// WEBPACK FOOTER //
// ./src/api/system-set.js